import React from "react";

export default function Unleash() {
  return (
    <div>
      <style>{`
      
        .feature-section {
          position: relative;
          overflow: hidden;
          background-color: #000000;
          padding: var(--section-padding);
        }
        .unleash-bg-video {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 0;
          opacity: 0.35;
        }
        .feature-section .container {
          position: relative;
          z-index: 2;
        }

        .title-basic h2 {
          font-family: var(--font-primary);
          font-size: var(--h2-size);
          font-weight: var(--h2-weight);
          line-height: var(--lh-tight);
          margin-bottom: var(--margin-title);
          text-align: center;
        }

        .feature-section .feature-box {
          background: #ffffff !important;
          border-radius: 16px;
          padding: 30px 20px;
          border: 1px solid rgba(0, 0, 0, 0.05);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          transition: all 0.4s ease;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
        }

        .feature-section .feature-box:hover {
          transform: translateY(-8px);
          box-shadow: 0 15px 40px rgba(var(--theme-color-rgb), 0.2);
          border-color: rgba(var(--theme-color-rgb), 0.3);
          background: #ffffff !important;
        }

        .feature-section .feature-box h3 {
          font-family: var(--font-primary);
          color: #111111 !important;
          font-weight: 700;
          font-size: 1.1rem;
          line-height: 1.4;
          margin-top: 20px;
          transition: color 0.3s ease;
        }

        .feature-section .feature-box:hover h3 {
          color: var(--theme-color) !important;
        }

        .feature-section .feature-box .feature-icon {
          width: 65px;
          height: 65px;
          background: rgba(var(--theme-color-rgb), 0.08) !important;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          transition: all 0.4s ease;
        }

        .feature-section .feature-box:hover .feature-icon {
          transform: scale(1.1);
        }

        /* Color SVG to primary red (#d6293a) */
        .feature-section .feature-box .outline-icon {
          width: 32px;
          height: 32px;
          filter: brightness(0) saturate(100%) invert(75%) sepia(21%) saturate(769%) hue-rotate(346deg) brightness(90%) contrast(88%) !important;
          transition: all 0.4s ease;
        }
      `}</style>
      <section className="feature-section section-b-space">
        <video autoPlay loop muted playsInline className="unleash-bg-video">
          <source src="/agn_identifies.mp4" type="video/mp4" />
        </video>
        <div className="bg-effect">
          {/* Other media removed as requested */}
        </div>
        <div className="container">
          <div className="title-basic">
            <h2 className="text-white">
              AGN Identifies & Delivers Financial Opportunities Through






            </h2>
          </div>
          <div className="swiper featureSlider">
            <div id="featureSlider" className="swiper-wrapper">
              <div className="swiper-slide">
                <div className="row g-xxl-5 g-4">
                  <div className="col-xl-3 col-lg-4 col-sm-6">
                    <div className="feature-box">
                      <div className="feature-top">
                        <div className="feature-icon">
                          <img
                            src="assets/svg/home/market_reading.svg"
                            className="img-fluid outline-icon"
                            alt=""
                          />
                        </div>
                        <h3 className="p-0">

                          Structured Asset Allocation


                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-sm-6">
                    <div className="feature-box">
                      <div className="feature-top">
                        <div className="feature-icon">
                          <img
                            src="assets/svg/home/technical_analysis.svg"
                            className="img-fluid outline-icon"
                            alt=""
                          />
                        </div>
                        <h3 className="p-0"> Market-Based Lending Models


                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-sm-6">
                    <div className="feature-box">
                      <div className="feature-top ">
                        <div className="feature-icon">
                          <img
                            src="assets/svg/home/trend_identification.svg"
                            className="img-fluid outline-icon"
                            alt=""
                          />
                        </div>
                        <h3 className="p-0">  Optimized Income Distribution



                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-sm-6">
                    <div className="feature-box">
                      <div className="feature-top">
                        <div className="feature-icon">
                          <img
                            src="assets/svg/home/arbitrage_findings.svg"
                            className="img-fluid outline-icon"
                            alt=""
                          />
                        </div>
                        <h3 className="p-0"> Recurring Revenue Systems


                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-sm-6">
                    <div className="feature-box">
                      <div className="feature-top">
                        <div className="feature-icon">
                          <img
                            src="assets/svg/home/high_frequency_trading.svg"
                            className="img-fluid outline-icon"
                            alt=""
                          />
                        </div>
                        <h3 className="p-0">  Network Expansion Rewards


                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-sm-6">
                    <div className="feature-box">
                      <div className="feature-top">
                        <div className="feature-icon">
                          <img
                            src="assets/svg/home/algorithmic_trading.svg"
                            className="img-fluid outline-icon"
                            alt=""
                          />
                        </div>
                        <h3 className="p-0"> Smart Financial Planning


                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-sm-6">
                    <div className="feature-box">
                      <div className="feature-top">
                        <div className="feature-icon">
                          <img
                            src="assets/svg/home/token_sniping.svg"
                            className="img-fluid outline-icon"
                            alt=""
                          />
                        </div>
                        <h3 className="p-0">Risk Distribution Strategy


                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-sm-6">
                    <div className="feature-box">
                      <div className="feature-top">
                        <div className="feature-icon">
                          <img
                            src="assets/svg/home/copy_trading.svg"
                            className="img-fluid outline-icon"
                            alt=""
                          />
                        </div>
                        <h3 className="p-0">
                          Global Participation Model



                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="pagination-effect">
          <img
            src="https://themes.pixelstrap.net/mega_bot/assets/svg/pagination-robot.svg"
            className="img-fluid"
            alt=""
          />
        </div>
        <div className="swiper-pagination feature-pagination" /> */}
      </section>
    </div>
  );
}
